export const getLangFromUrl = (url: string): string | null => {
    const path = url.replace(/^https?:\/\/[^/]+/, '');
    const match = path.match(/^\/(fr|pt|en)(\/|$)/);
    return match ? match[1] : null;
};